export default {
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: false,
    infinite: false,
    draggable: false,
    responsive: [
      {
        breakpoint: 1200,
        settings:{
          slidesToShow: 2,
          slidesToScroll: 2,
          centerMode: false
        }
      },
      {
        breakpoint: 768,
        settings:{
          slidesToShow: 2,
          slidesToScroll: 2,
          centerMode: false
        }
      },
      // {
      //   breakpoint: 585,
      //   settings:{
      //     slidesToShow: 1,
      //     slidesToScroll: 1,
      //     centerMode: false
      //   }
      // }
    ]
  }